






















































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'

settings =
  name: 'OrganizerStorefrontShowPage'

  vue:
    data: ->
      item: null
      accordionActiveGroup: null

    mounted: ->
      @fetchStorefront()

    methods:
      fetchStorefront: ->
        try
          { data } = await RecessAPI.get "api/v2/stores/#{@$route.params.storefrontSlug}"
          @item = data
        catch ex
          console.error ex

export default VueOptions.vue settings
